export default __webpack_public_path__ + "static/media/waterfall.0e96a261.gif";